<h1 mat-dialog-title>Confirmación</h1>
<div mat-dialog-content>
    <p>{{ data.question }}</p>
    <div>
        <form [formGroup]="form" autocomplete="off">
            <input autocomplete="false" name="hidden" type="text" style="display: none" />
            <mat-form-field appearance="fill">
                <input
                    matInput
                    type="text"
                    placeholder="{{ data.hint }}"
                    [formControl]="form.controls['fieldValue']"
                    autocomplete="new-password"
                />
            </mat-form-field>
        </form>
    </div>
</div>
<div mat-dialog-actions>
    <button mat-raised-button color="accent" (click)="onCancelClick()" tabindex="2">Cancelar</button>
    <button mat-raised-button color="primary" (click)="onConfirmClick()" tabindex="1">Si</button>
</div>
